import { render } from "./DashboardLegal.vue?vue&type=template&id=1808ec57"
import script from "./DashboardLegal.vue?vue&type=script&lang=js"
export * from "./DashboardLegal.vue?vue&type=script&lang=js"

import "./DashboardLegal.vue?vue&type=style&index=0&id=1808ec57&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__